import { Button, IconButton, styled } from '@mui/material';

export const StyledGoalsEditButtonWrap = styled('div')<{ isEditing: boolean }>(({ isEditing }) => ({
	position: 'absolute',

	top: '16px',
	right: '8px',

	'& .MuiSvgIcon-root': {
		fontSize: '16px',
	},

	...(isEditing && {
		position: 'fixed',
		bottom: '16px',
		left: '16px',
		right: '16px',
		top: 'unset',
	}),
}));

export const StyledGoalsEditButtonIconButton = styled(IconButton)({
	width: '40px',
	height: '40px',
});

export const StyledGoalsEditButtonwWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '16px',

	background: '#FFFFFF',
	borderRadius: '12px',
	padding: '12px 8px 12px 8px',
}));

export const StyledGoalsEditButton = styled(Button)(({ theme }) => ({
	width: '100px',
	paddingBlock: '7px',
	height: 'auto',
	lineHeight: '24px',

	[theme.breakpoints.down('sm')]: {
		flex: 1,
	},
}));
